var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.763,
    height: 47.539,
    viewBox: "0 0 50.763 47.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13347",
    "data-name": "Group 13347",
    transform: "translate(-933.641 -317.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13291",
    "data-name": "Group 13291",
    transform: "translate(-47.117 728.558) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    transform: "translate(962 425)",
    fill: "none",
    stroke: "#157fee",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.326,
    cy: 11.326,
    r: 11.326,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.326,
    cy: 11.326,
    r: 9.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6029",
    "data-name": "Path 6029",
    d: "M1473.18-13726h30.8",
    transform: "translate(-490.075 14162.327)",
    fill: "none",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6030",
    "data-name": "Path 6030",
    d: "M1483.891-13726v10.777",
    transform: "translate(-482.889 14162.327)",
    fill: "none",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6031",
    "data-name": "Path 6031",
    d: "M1483.891-13726v10.777",
    transform: "translate(-476.206 14162.327)",
    fill: "none",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6034",
    "data-name": "Path 6034",
    d: "M946.785,336.711c.057-.747-.293-2.634,2.609-2.634a2.4,2.4,0,0,1,2.59,3.222c-.253.884-2.59,1.7-2.59,3.474",
    transform: "translate(0 10.148)",
    fill: "none",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6035",
    "data-name": "Path 6035",
    d: "M949.44,342.551v.067",
    transform: "translate(0 11.148)",
    fill: "#157fee",
    stroke: "#157fee",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.59cad818c1c9a820da015bc9204903f0.svg";
export { ForwardRef as ReactComponent };